// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Ape651gOL8n079GdiGDd {
  width: 100%;
  max-width: var(--campaign-tab-width);
  margin: 0 auto;
  flex: 1;
  overflow-y: auto;
  background-color: #1c1c1e;
}
._A8Y0DhLgil4FQS3G__3 {
  width: 100%;
  max-width: var(--campaign-tab-width);
  border: 1.5px solid #272727;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);
  display: block;
}
.uNfQF6PhRS5nhZd7et43,
.nhudG9l4MicPwPF6bXwt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: var(--campaign-tab-width);
  overflow: hidden;
}
.uNfQF6PhRS5nhZd7et43 {
  background-color: #1c1c1e;
  border-radius: 12px 12px 0 0;
  /* height: calc(100% - var(--navigation-height)); */
}
.nhudG9l4MicPwPF6bXwt {
  border-radius: 0 0 12px 12px;
}
.nhudG9l4MicPwPF6bXwt .LNhAMU4H8P72TCnJ5DCk:last-child {
  border-bottom: none;
}
.LNhAMU4H8P72TCnJ5DCk {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  color: white;
  height: 48px;
  padding: 6px 8px;
  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);
  position: relative;
}
/* @media (--campaign-mobile) and (orientation: portrait) {
  .tabContainer {
    max-width: 359px;
  }

  .table {
    max-width: 359px;
  }

} */
@media (orientation: portrait) {
  .Ape651gOL8n079GdiGDd {
    width: 95%;
    margin: 12px 0;
  }
  ._A8Y0DhLgil4FQS3G__3 {
    width: 100%;
    /* display: block; */
  }
  .uNfQF6PhRS5nhZd7et43,
  .nhudG9l4MicPwPF6bXwt {
    width: 100%;
  }
}
.A7buZzn4WzNRD11YPD7D {
  position: relative;
  background-color: #212121;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  text-align: center;
  font-size: 22px;
  line-height: normal;
  letter-spacing: normal;
  font-style: normal;
  color: #d4d4d4;
}
.HwRDe656Jq6tkMFgaDVo,
.iav06pijfauprQEcd4Rc {
  display: flex;
  width: 20%;
  font-family: var(--font-family-secondary, inherit);
}
.HwRDe656Jq6tkMFgaDVo:first-child,
.iav06pijfauprQEcd4Rc:first-child {
  justify-content: flex-start;
}
.HwRDe656Jq6tkMFgaDVo:nth-child(2),
.iav06pijfauprQEcd4Rc:nth-child(2) {
  justify-content: center;
}
.HwRDe656Jq6tkMFgaDVo:last-child,
.iav06pijfauprQEcd4Rc:last-child {
  justify-content: flex-end;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .A7buZzn4WzNRD11YPD7D {
  gap: 0;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .HwRDe656Jq6tkMFgaDVo:first-child,
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .iav06pijfauprQEcd4Rc:first-child {
  flex: 4;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .HwRDe656Jq6tkMFgaDVo:nth-child(2),
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .iav06pijfauprQEcd4Rc:nth-child(2) {
  justify-content: flex-start;
  flex: 4;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .HwRDe656Jq6tkMFgaDVo:last-child,
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .iav06pijfauprQEcd4Rc:last-child {
  flex: 1;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winners'] .nhudG9l4MicPwPF6bXwt {
  padding-bottom: 4px;
}
._A8Y0DhLgil4FQS3G__3[data-table-type='winnings'] .LNhAMU4H8P72TCnJ5DCk {
  padding: 6px 15px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  ._A8Y0DhLgil4FQS3G__3[data-table-type='winnings'] .LNhAMU4H8P72TCnJ5DCk {
    padding: 4px 10px;
  }
}
.HwRDe656Jq6tkMFgaDVo {
  font-weight: 100;
  font-family: var(--font-family-primary, inherit);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .A7buZzn4WzNRD11YPD7D {
    font-size: 15px;
    height: 32px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/CampaignTable/CampaignTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,OAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mDAAmD;AACrD;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mDAAmD;EACnD,kBAAkB;AACpB;AACA;;;;;;;;;GASG;AACH;EACE;IACE,UAAU;IACV,cAAc;EAChB;EACA;IACE,WAAW;IACX,oBAAoB;EACtB;EACA;;IAEE,WAAW;EACb;AACF;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,UAAU;EACV,kDAAkD;AACpD;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;AACzB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,MAAM;AACR;AACA;;EAEE,OAAO;AACT;AACA;;EAEE,2BAA2B;EAC3B,OAAO;AACT;AACA;;EAEE,OAAO;AACT;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,gBAAgB;EAChB,gDAAgD;AAClD;AACA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":[".tabContainer {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  margin: 0 auto;\n  flex: 1;\n  overflow-y: auto;\n  background-color: #1c1c1e;\n}\n.table {\n  width: 100%;\n  max-width: var(--campaign-tab-width);\n  border: 1.5px solid #272727;\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 10px;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.5);\n  display: block;\n}\n.tableHead,\n.tableBody {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  max-width: var(--campaign-tab-width);\n  overflow: hidden;\n}\n.tableHead {\n  background-color: #1c1c1e;\n  border-radius: 12px 12px 0 0;\n  /* height: calc(100% - var(--navigation-height)); */\n}\n.tableBody {\n  border-radius: 0 0 12px 12px;\n}\n.tableBody .tableRow:last-child {\n  border-bottom: none;\n}\n.tableRow {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  height: 48px;\n  padding: 6px 8px;\n  border-bottom: 0.5px solid rgba(101, 101, 101, 0.3);\n  position: relative;\n}\n/* @media (--campaign-mobile) and (orientation: portrait) {\n  .tabContainer {\n    max-width: 359px;\n  }\n\n  .table {\n    max-width: 359px;\n  }\n\n} */\n@media (orientation: portrait) {\n  .tabContainer {\n    width: 95%;\n    margin: 12px 0;\n  }\n  .table {\n    width: 100%;\n    /* display: block; */\n  }\n  .tableHead,\n  .tableBody {\n    width: 100%;\n  }\n}\n.tableHeaderRow {\n  position: relative;\n  background-color: #212121;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  text-align: center;\n  font-size: 22px;\n  line-height: normal;\n  letter-spacing: normal;\n  font-style: normal;\n  color: #d4d4d4;\n}\n.tableHeaderCell,\n.tableCell {\n  display: flex;\n  width: 20%;\n  font-family: var(--font-family-secondary, inherit);\n}\n.tableHeaderCell:first-child,\n.tableCell:first-child {\n  justify-content: flex-start;\n}\n.tableHeaderCell:nth-child(2),\n.tableCell:nth-child(2) {\n  justify-content: center;\n}\n.tableHeaderCell:last-child,\n.tableCell:last-child {\n  justify-content: flex-end;\n}\n.table[data-table-type='winners'] .tableHeaderRow {\n  gap: 0;\n}\n.table[data-table-type='winners'] .tableHeaderCell:first-child,\n.table[data-table-type='winners'] .tableCell:first-child {\n  flex: 4;\n}\n.table[data-table-type='winners'] .tableHeaderCell:nth-child(2),\n.table[data-table-type='winners'] .tableCell:nth-child(2) {\n  justify-content: flex-start;\n  flex: 4;\n}\n.table[data-table-type='winners'] .tableHeaderCell:last-child,\n.table[data-table-type='winners'] .tableCell:last-child {\n  flex: 1;\n}\n.table[data-table-type='winners'] .tableBody {\n  padding-bottom: 4px;\n}\n.table[data-table-type='winnings'] .tableRow {\n  padding: 6px 15px;\n}\n@media (--campaign-mobile) {\n  .table[data-table-type='winnings'] .tableRow {\n    padding: 4px 10px;\n  }\n}\n.tableHeaderCell {\n  font-weight: 100;\n  font-family: var(--font-family-primary, inherit);\n}\n@media (--campaign-mobile) {\n  .tableHeaderRow {\n    font-size: 15px;\n    height: 32px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContainer": `Ape651gOL8n079GdiGDd`,
	"table": `_A8Y0DhLgil4FQS3G__3`,
	"tableHead": `uNfQF6PhRS5nhZd7et43`,
	"tableBody": `nhudG9l4MicPwPF6bXwt`,
	"tableRow": `LNhAMU4H8P72TCnJ5DCk`,
	"tableHeaderRow": `A7buZzn4WzNRD11YPD7D`,
	"tableHeaderCell": `HwRDe656Jq6tkMFgaDVo`,
	"tableCell": `iav06pijfauprQEcd4Rc`
};
export default ___CSS_LOADER_EXPORT___;
